import { Autocomplete, textFieldVariants } from '@ghs/components';
import { Box, Stack } from '@mui/material';
import type { CampaignSetupJobOption, CampaignSetupOption, EditFormData } from './types';

type Props = {
  formData: Partial<EditFormData>;
  clientOptions: CampaignSetupOption[];
  campaignOptions: CampaignSetupJobOption[];
  onChange: (patch: Partial<EditFormData>) => void;
};

export default function SelectCampaignSection({ formData, clientOptions, campaignOptions, onChange }: Props) {
  const hasClientSelected = Boolean(formData.clientId);
  const requiredLabelSx = {
    '& .MuiInputLabel-root::before': {
      content: '"* "',
      color: 'error.main'
    }
  };
  const campaignDropdownOptions = hasClientSelected
    ? campaignOptions.map(opt => ({
        id: opt.id,
        name: opt.name,
        number: opt.number,
        label: `${opt.name} - ${opt.number}`
      }))
    : [];

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'stretch', md: 'center' }} spacing={2}>
      <Box sx={{ flex: 1 }}>
        <Autocomplete
          id="edit-client"
          label="Client"
          placeholder="Select a client..."
          options={clientOptions}
          variant={textFieldVariants.OUTLINED}
          sx={{ width: '100%', ...requiredLabelSx }}
          value={clientOptions.find(opt => opt.id === formData.clientId) || null}
          onChange={(_event, value) => onChange({ clientId: value?.id || null })}
          getOptionKey={opt => opt.id}
        />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Autocomplete
          id="edit-campaign"
          label="Campaign"
          placeholder={hasClientSelected ? 'Select a campaign...' : 'Select a client first'}
          options={campaignDropdownOptions}
          variant={textFieldVariants.OUTLINED}
          sx={{ width: '100%', ...requiredLabelSx }}
          disabled={!hasClientSelected}
          value={
            campaignDropdownOptions.find(opt => opt.name === formData.campaignName && opt.number === formData.campaignNumber) ||
            campaignDropdownOptions.find(opt => opt.name === formData.campaignName || opt.number === formData.campaignNumber) ||
            null
          }
          onChange={(_event, value) => onChange({ campaignName: value?.name || null, campaignNumber: value?.number || null })}
          getOptionKey={opt => opt.id}
        />
      </Box>
    </Stack>
  );
}
